import React from 'react';
import { JobDto, PostDto } from 'src/api/FiretrolApiClient';
import { Modal } from 'src/design/molecules/Modal';
import { PostForm } from 'src/routes/Jobs/ActivityFeed/components/PostCard/components/PostForm';

interface EditPostProps {
  onPostSaved: () => void;
  handleClose: () => void;
  post: PostDto | null;
  job?: JobDto;
}

export const EditPost: React.FC<EditPostProps> = ({
  onPostSaved,
  handleClose,
  post,
  job,
}) => {
  return (
    <Modal
      opened={post !== null}
      onClose={handleClose}
      title="Edit Post"
      size="xl"
    >
      <PostForm
        handleClose={handleClose}
        onPostCreated={onPostSaved}
        initialValues={post}
        job={job}
      />
    </Modal>
  );
};
